import { Box, Toolbar } from '@mui/material'
import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import ButtonList from '../../../components/Button/ButtonList'

const Body = () => {
  const url = useLocation().pathname
  return (
    <Box
      style={{ display: 'flex', flexDirection: 'column' }}
      component="main"
      sx={{
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme),
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <Toolbar />
      {(url !== '/' && <ButtonList />) && (url !== '/ba' && <ButtonList />) && (!url.startsWith('/BIViewer/card/') && <ButtonList />) &&
        (url !== '/reportingDesigner' && <ButtonList />) && (url !== '/BIViewer' && <ButtonList />)}
      <Box component="main" sx={{
        flexGrow: 1,
        p: (url !== '/reportingDesigner' && url !== '/BIViewer' && !url.startsWith('/BIViewer/card/') && url !== '/ba') ? 3 : 0,
        display: 'flex', flexDirection: 'column'
      }} >
        <Outlet />
      </Box>
    </Box>
  )
}

export default Body
